/**
 * Whether two coordinate pairs represent the same point within `epsilon`
 * degrees. Default tolerance ~0.5 m at the equator — small enough to catch
 * real edits but large enough to ignore float noise from spurious `moveend`
 * events. `null` inputs are equal only to other `null`s.
 */
export function sameCoord(a, b, epsilon = 5e-6) {
  if (!a || !b) return a === b;
  return Math.abs(a.latitude - b.latitude) < epsilon && Math.abs(a.longitude - b.longitude) < epsilon;
}

/** Get the user's current position via the browser Geolocation API */
export function getBrowserLocation(timeout = 10000) {
  return new Promise(resolve => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(pos => resolve({
      latitude: pos.coords.latitude,
      longitude: pos.coords.longitude
    }), () => resolve(null), {
      enableHighAccuracy: true,
      timeout
    });
  });
}